<template>
  <div>
    <HeaderA></HeaderA>
    <div class="container">
      <iframe :src="src" scrolling="no" frameborder="0"></iframe>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import HeaderA from "@/components/public/headerA";
export default {
  data() {
    return {
      src: this.$store.state.virtualSrc.length
        ? this.$store.state.virtualSrc
        : "static/html/time.html"
    };
  },
  components: {
    HeaderA
  },
  activated() {
    this.$nextTick(function() {
      $(".container").height(
        $(window).height() - $(".header_box").height() - 0
      );
      $("#headerContainer601").addClass("active");
    });
  },
  mounted() {
    if(this.$store.state.virtualSrc.length){
      this.src = this.$store.state.virtualSrc
    }else if(sessionStorage.getItem("virtualSrc").length){
      this.src = sessionStorage.getItem("virtualSrc")
    } else {
      this.src = "static/html/time.html"
    }
  }

};
</script>

<style scoped="scoped">
.container iframe {
  display: block;
  position: relative;
  top: -1px;
  width: 100%;
  height: calc(100% + 1px);
}
</style>



// WEBPACK FOOTER //
// src/components/virtualExperience/virtualExperience.vue